import React from 'react';
import { Col, Form, Row } from 'antd';
import { useSelector } from 'react-redux';
import { createDecimalRegExp } from 'utils/patterns';
import { aplicacionesCargosEnum } from 'views/Tramites/GPM/enums';
import NumericInput from 'components/NumericInput';
import PropTypes from 'prop-types';
import FormItemByMoneda from './FormItemsByMoneda';

const FormItemsByApplicationType = ({
  tipoDeAplicacion,
  moneda,
  mutable,
  allowZero,
}) => {
  const form = Form.useFormInstance();
  const monedaDefault = useSelector(({ auth }) => auth.entidad?.moneda);
  const [decimal] = createDecimalRegExp(monedaDefault);

  const requiredRule = { required: true };
  const rules = {
    importe_maximo: [
      requiredRule,
      {
        validator: async () => {
          const values = form.getFieldsValue(['importe_minimo', 'importe_maximo']);
          const importe_minimo = parseFloat(values.importe_minimo);
          const importe_maximo = parseFloat(values.importe_maximo);
          if (values.importe_maximo) {
            if (!decimal.test(values.importe_maximo)) {
              throw new Error('Ingrese un valor decimal válido');
            } else if (importe_maximo <= importe_minimo) {
              throw new Error('El campo debe ser mayor al Importe Mínimo');
            }
          }
        },
      },
    ],
    importe_minimo: [
      requiredRule,
      {
        validator: async () => {
          const values = form.getFieldsValue(['importe_minimo', 'importe_maximo']);
          const importe_minimo = parseFloat(values.importe_minimo);
          const importe_maximo = parseFloat(values.importe_maximo);
          if (values.importe_minimo) {
            if (!decimal.test(values.importe_minimo)) {
              throw new Error('Ingrese un valor decimal válido');
            } else if (importe_minimo >= importe_maximo) {
              throw new Error('El campo debe ser menor al Importe Máximo');
            }
          }
        },
      },
    ],
  };

  if (aplicacionesCargosEnum.CAPTURABLE === tipoDeAplicacion) {
    return (
      <Col span={24}>
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              rules={rules.importe_minimo}
              name="importe_minimo"
              label="Importe mínimo"
              disabled={!mutable}
              decimal
              currency
            />
          </Col>
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              rules={rules.importe_maximo}
              name="importe_maximo"
              label="Importe máximo"
              disabled={!mutable}
              decimal
              currency
            />
          </Col>
        </Row>
      </Col>
    );
  }

  if (aplicacionesCargosEnum.FIJO === tipoDeAplicacion) {
    return (
      <Col span={24}>
        <Row gutter={10}>
          <FormItemByMoneda
            moneda={moneda}
            mutable={mutable}
            allowZero={allowZero}
          />
        </Row>
      </Col>
    );
  }

  return null;
};

FormItemsByApplicationType.propTypes = {
  tipoDeAplicacion: PropTypes.oneOf(Object.values(aplicacionesCargosEnum)),
  moneda: PropTypes.number.isRequired,
  mutable: PropTypes.bool.isRequired,
  allowZero: PropTypes.bool.isRequired,
};

FormItemsByApplicationType.defaultProps = {
  tipoDeAplicacion: null,
};

export default FormItemsByApplicationType;
